import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './styles.scss'; // eslint-disable-line

const LoadingLayerComponent = (props) => {
  const {loadingStr, show} = props;

  function getLayout() {
	if (show === true) {
	  return (
		  <div styleName="wrapper">
			<div styleName="content">
			  <div styleName="icon"></div>
			  <div styleName="text">{loadingStr}</div>
			</div>
		  </div>
	  );
	} else {
	  return null;
	}
  }

  return (
	  getLayout()
  );
};

LoadingLayerComponent.propTypes = {
  show: PropTypes.bool.isRequired,
  loadingStr: PropTypes.string
};

LoadingLayerComponent.defaultProps = {
  show: false,
  loadingStr: 'Loading...'
};

export default CSSModules(LoadingLayerComponent, styles);



// WEBPACK FOOTER //
// ./components/qual/Table/LoadingLayer/LoadingLayerComponent.js